import profit from '@js/store/modules/profit';

export default {
    created() {
        if (!this.$store.hasModule('profit')) {
            this.$store.registerModule('profit', profit);
        }
    },
};
